export default __webpack_public_path__ + "static/media/bitcoin2.b8ba9088.jpg";